import { validateEmail } from '../formats/validateEmail'
import { validatePhoneNumber } from '../formats/validatePhoneNumber'
import { validateBirthdate } from '../formats/validateBirthdate'
import { validateFullName } from '../formats/validateFullName'

/**
 *
 * @param {HTMLInputElement} input
 * @returns {boolean}
 */
export function checkInputValidity(input) {
  const checkValidityTypes = ['text']

  if (checkValidityTypes.includes(input.type) && !input.checkValidity()) {
    return false
  }

  if (input.name === 'name' && !validateFullName(input.value)) {
    return false
  }

  if (input.type === 'tel' && !validatePhoneNumber(input.value)) {
    return false
  }

  if (input.type === 'email' && !validateEmail(input.value)) {
    return false
  }

  if (input.name === 'birthdate' && !validateBirthdate(input.value)) {
    return false
  }

  if (input.type === 'number' && Number.isNaN(parseInt(input.value))) {
    return false
  }

  return true
}
